import { ColumnConfig } from '../base-column/column.model';
import { Currencies } from '../currency-column/currencies-enum';
import { CurrencyPosition } from '../currency-column/currency-position-enum';
import { styleProperties } from './style.model';

export function initFromConfig<T>(column: any, config: ColumnConfig<T>) {
  column.PropertyName = config.propertyName ?? '';
  column.Name = config.name ?? '';
  column.Sort = config.sort ?? false;
  column.Cases = config.cases ?? {};
  column.Tooltip = config.tooltip ?? '';
  column.Action = config.action;

  column.CurrencySymbol = config.currencySymbol ?? Currencies.Euro;
  column.CurrencyPosition = config.currencyPosition ?? CurrencyPosition.After;
  column.DecimalSeperator = config.decimalSeperator ?? ',';
  column.ThousandsSeperator = config.thousandsSeperator ?? '.';

  column.ConvertToLocalTimeZone = config.convertToLocalTimeZone ?? false;
  column.Format = config.format ?? null;
  column.ParseFormat = config.parseFormat ?? 'dd/MM/yyyy';

  column.ColumnClassProperties = config.classProperties;
  column.isVisibleAction = config.isVisibleAction;
  column.isDisabledAction = config.isDisabledAction;
  column.frozen = config.frozen;
  column.alignFrozen = config.alignFrozen;
  column.visible = config.visible;
  column.disabled = config.disabled;
}

export function initFromConfigButton<T>(column: any, config: ColumnConfig<T>) {
  column.Action = config.action;
  column.ColumnClassProperties = config.classProperties;
  column.isVisibleAction = config.isVisibleAction;
  column.isDisabledAction = config.isDisabledAction;
  column.frozen = config.frozen;
  column.alignFrozen = config.alignFrozen;
}

export function initFromProps<T>(
  column: any,
  name?: string,
  propertyName?: string,
  sort?: boolean,
  tooltip?: string | ((item?: any) => string),
  action?: (item?: T, event?: any) => any,
  cases?: { [key: symbol]: () => T }
) {
  column.PropertyName = propertyName ?? '';
  column.Name = name ?? '';
  column.Sort = sort ?? false;
  column.Tooltip = tooltip ?? '';
  column.Action = action;
  column.Cases = cases;
}

export function initFromPropsButtons<T>(
  column: any,
  title?: string,
  icon?: string | ((item?: any) => string),
  styleClass?: string | ((item?: any) => string),
  style?: styleProperties,
  pTooltip?: string | ((item?: any) => string),
  tooltipPosition?: string,
  action?: (item?: T, event?: any) => any,
  isVisibleAction?: (item?: T) => boolean,
  isDisabledAction?: (item?: T) => boolean
) {
  const button = {
    title: title,
    icon: icon,
    styleClass: styleClass,
    style: style,
    pTooltip: pTooltip,
    tooltipPosition: tooltipPosition,
  };

  column.ColumnClassProperties = button;

  column.Action = action;
  column.isVisibleAction = isVisibleAction;
  column.isDisabledAction = isDisabledAction;
}
